var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.32 12.9465C20.92 12.9465 22 11.9465 21.04 8.66647C20.39 6.45647 18.49 4.55647 16.28 3.90647C13 2.94647 12 4.02647 12 6.62647V9.50647C12 11.9465 13 12.9465 15 12.9465H18.32Z",
    stroke: "#1F2933",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0004 15.6461C19.0704 20.2761 14.6304 23.6361 9.58042 22.8161C5.79042 22.2061 2.74042 19.1561 2.12042 15.3661C1.31042 10.3361 4.65042 5.89605 9.26042 4.95605",
    stroke: "#1F2933",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLog);
export default __webpack_public_path__ + "static/media/log.87c58f189e606be4a9ee5a572d69814a.svg";
export { ForwardRef as ReactComponent };